import { omit } from 'ramda'
import type { Obj } from '#/utils'
import { dispatchServer } from '@/views/Login/js/rc'
import { TOKEN_KEY, OUTER_TOKEN_KEY } from './enums/cache'
import { routerInit } from './router/permission'
import { useUserStoreWithoutSetup } from './store/modules/user'
import { getParams } from './utils'
import { getAuthCache, setAuthCache } from './utils/auth'
import { TOKEN_FROM, isReferrerFromAuthBackup, setTokenFrom, toOuterLogin } from './utils/login'
import { OUTER_USER_TYPE } from './views/UserAccounts/js/config'
import { isFullRedirectPath } from './router/auth-routes'
import { BOOLEAN } from './utils/constants'
import { setBasisToken, setLpToken } from './utils/micro-app'
import { GET_JZT_CHANNEL_LIST_ASYNC } from './utils/jztChannelListConfig'

/** app初始化是否完成 */
export const appInited = ref(false)

/** 初始化app */
export async function init() {
  const isGoingLogin = window.location.pathname === '/login'
  if (isGoingLogin) {
    appInited.value = true
    routerInit()
    return
  }
  try {
    await handleToken()
    appInited.value = true
    routerInit()
    GET_JZT_CHANNEL_LIST_ASYNC()
  } catch (error) {
    console.error('[Fail]while initing app: ', error)
    const err = error as Error
    GMessage.error(err?.message || err)
    toOuterLogin({
      fullPath: isFullRedirectPath(window.location.pathname),
      mobile: isFullRedirectPath(window.location.pathname)
    })
  }
}
/** token处理 */
async function handleToken() {
  const { token, from, query, lpToken } = getUrlTokenFrom()
  if (token) {
    setTokenFrom(from)
    setBasisToken(token)
    setAuthCache(OUTER_TOKEN_KEY, token)
    // 无 lpToken 时显式清空，避免子应用复用上一用户的 localStorage
    setLpToken(lpToken ?? '')
    await leyoKeyLogin(token, from, query, lpToken)
  } else {
    checkCacheToken()
  }
}
/**
 * 获取url的token信息
 * 【leyokey => iSupplier】?token=xxx&from=leyokey
 * 【srm => iSupplier】?token=xxx&from=srm
 */
export function getUrlTokenFrom() {
  const query = getParams(window.location.href)
  const from = (query.from as string) || 'srm'
  let lpToken = query.lpToken as string
  let token = query.token as string
  if (token) token = window.atob(window.atob(token))
  if (lpToken) lpToken = window.atob(window.atob(lpToken))
  return {
    token,
    from,
    /** 访问具体页面的参数 */
    query: omit(['from', 'token', 'lpToken'], query),
    lpToken
  }
}

const loading = ref(false)

/** 从leyokey跳转登入 */
async function leyoKeyLogin(outerToken: string, from: string, query: Obj, lpToken: string) {
  const userStore = useUserStoreWithoutSetup()
  const router = useRouter()
  const outerUserType = from === TOKEN_FROM.LEYOKEY ? OUTER_USER_TYPE.LEYOKEY : OUTER_USER_TYPE.SRM
  const params = {
    outerToken,
    outerUserType,
    // 告诉后端是否从auth8登录跳转
    beAuth8: isReferrerFromAuthBackup() ? BOOLEAN.YES : BOOLEAN.NO,
    payCenterToken: lpToken
  }
  try {
    loading.value = true
    const data = await userStore.outerLogin(params)
    const { userInfo } = data
    const jump = dispatchServer(userInfo.beLoginRc)
    if (jump) {
      jump()
    } else {
      await userStore.loadLoginInfo(data)
      router.push({ path: window.location.pathname, query })
    }
  } catch (error) {
    return Promise.reject(error)
  } finally {
    loading.value = false
  }
}
/** 检查是否有登录token缓存 */
function checkCacheToken() {
  const token = getAuthCache(TOKEN_KEY)
  const outerToken = getAuthCache(OUTER_TOKEN_KEY) as string
  if (token) {
    if (outerToken) {
      setBasisToken(outerToken)
    }
    return
  }
  const message = '用户未登录'
  GMessage.error(message)
  throw new Error(message)
}
